<template lang="html">

  <section class="ficha -observaciones">
    <template  v-if="!!brand.observacionesManuales">
      <h2 class="ficha-title" :style="styles.colorBasic">
        Observaciones de la práctica
      </h2>
      <template v-for="(observacion, key) in observacionesManuales"  v-if="observacionesManuales.length > 0">
        <observacion-manual-el :data="observacion"></observacion-manual-el>
      </template>
       <div class="contenedor-botones row-center" :style="styles.backgroundWhite" style="width: 100%; padding: 25px;">
        <a class="btn -xs" :style="styles.solidPrimary" @click="showPopupObservacionManual = true">Añadir observación / Seguimiento</a>
      </div>
    </template>
   
    <template  v-if="observaciones.length > 0">
      <h2 class="ficha-title" :style="styles.colorBasic">
        Observaciones de validación
      </h2>
      <template v-for="(observacion, key) in observaciones">
        <observacion-el :data="observacion"></observacion-el>
      </template>
    </template>
    <popup-observacion-manual v-if="showPopupObservacionManual" @cerrar="showPopupObservacionManual = false"    @observacionAnnadida="$emit('observacionAnnadida')"></popup-observacion-manual>     
    
    <template v-if="observaciones.length == 0 && (!brand.observacionesManuales || observacionesManuales.length == 0)">
      <p>Esta práctica no contiene observaciones</p>
    </template>

  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import observacion from '@/components/parts/observacion-el';
  import observacionManual from '@/components/parts/observacion-manual-el';

  import popupObservacionManual from '@/components/parts/popup-observacion-manual';
  
  import excel from '@/components/parts/icons/excel';
  import XLSX from 'xlsx';

  export default  {
    name: 'ficha-observaciones',
    props : ['observaciones', 'observacionesManuales'],
    data(){
      return{
        
        documentacion : [],
        showPopupObservacionManual: false,
      }
    },
    mounted(){

    },
    computed :{
      ...mapGetters({
        styles : 'getStyles',
        documentos :'getDocumentos',
        brand : 'getBrand',        
      })
    },
    methods : {
    	...mapActions(['dameContestacionEncuesta']),
      exportExcel() {
        
        let idPractica = this.$route.params.id;

        if (!!!idPractica & Number(this.$route.params.status) > 0) {
          idPractica = this.$route.params.status;
        }

        let data = XLSX.utils.json_to_sheet(this.observacionesManuales);
        const workbook = XLSX.utils.book_new();
        const date = new Date();
        const filename = String(`Observaciones - Práctica ${idPractica}`);
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      },
    },
    components : {
      'observacion-el' : observacion,
      'observacion-manual-el' : observacionManual,
      'popup-observacion-manual': popupObservacionManual,
      'excel': excel
    }
  }
</script>

<style scoped lang="scss">
  .ficha.-observaciones {
    .ficha-title{
      margin-top: 5px;

      &.-documentacion-practica{
        margin-top: 20px;
      }
    }

    p{
      text-align: left;
      width: 100%;
      display: inline-block;
      font-size: 14px;
    }

    .add-documentacion{
      cursor: pointer;
      margin-top: 10px;
    }
  }
  


</style>



// WEBPACK FOOTER //
// src/components/views/ficha-observaciones.vue